import React, { useContext, useState, useEffect } from "react";
import Card from "../../../UX/Card/Card";
import DatePicker, { registerLocale } from "react-datepicker";
import { subDays, addDays, endOfWeek, getDate, format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import nl from "date-fns/locale/nl";
import { ProductOptionStepsContext } from "../../../Providers/ProductOptionStepsProvider";
import { VerspreidenContext } from "../../../Providers/VerspreidenProvider"; // the locale you want
registerLocale("nl", nl); // register it with the name you want

const Verspreiddatum = props => {
    const { onSelectPriceAndVariation } = useContext(ProductOptionStepsContext);
    const { onVerspreidDatums, verspreidDatums } = useContext(
        VerspreidenContext
    );

    const [startDate, setStartDate] = useState(
        endOfWeek(addDays(new Date(), 14)),
        { weekStartsOn: 6 }
    );
    const [initDate, setInitDate] = useState(
        endOfWeek(addDays(new Date(), 14)),
        { weekStartsOn: 6 }
    );

    useEffect(() => {
        onVerspreidDatums(
            "Verspreiden tussen: " +
                format(startDate, "dd MMMMMM yyyy", { locale: nl }) +
                " en " +
                format(addDays(startDate, 3), "dd MMMMMM yyyy", { locale: nl })
        );
    }, [startDate]);

    const filterDatePickerDates = date => {
        return (
            date.getDay() === 6 ||
            date.getDay() === 0 ||
            date.getDay() === 1 ||
            date.getDay() === 2
        );
    };

    const setStartingSaturday = date => {
        if (date.getDay() === 6) {
            setStartDate(date);
        }
        if (date.getDay() === 0) {
            setStartDate(subDays(date, 1));
        }
        if (date.getDay() === 1) {
            setStartDate(subDays(date, 2));
        }
        if (date.getDay() === 2) {
            setStartDate(subDays(date, 3));
        }
        //onVerspreidDatums('Verspreiden tussen: '+format(startDate, "dd MMMMMM yyyy", {locale: nl})+' en '+format(addDays(startDate, 3), "dd MMMMMM yyyy", {locale: nl}));
    };

    const prices = props.items.prices[0];

    return (
        <div
            // onOpenInfoModal={props.onOpenInfoModal}
            // setRef={props.setRef}
            // loading={step.loading}
            // type={step.id}
            // title={step.description}
        >
            <DatePicker
                calendarClassName="customDatePicker"
                selected={startDate}
                onChange={date => setStartingSaturday(date)}
                inline
                filterDate={date => filterDatePickerDates(date)}
                startDate={startDate}
                endDate={addDays(startDate, 3)}
                minDate={initDate}
                locale="nl"
            />
            <div className="my-8">
                <p>
                    Verspreiden tussen:{" "}
                    <b>
                        {format(startDate, "dd MMMMMM yyyy", { locale: nl })} en{" "}
                        {format(addDays(startDate, 3), "dd MMMMMM yyyy", {
                            locale: nl
                        })}
                    </b>
                </p>
            </div>
            <div>
                <button
                    onClick={() =>
                        onSelectPriceAndVariation(
                            "offset",
                            prices.options[0].delivery,
                            prices.options[0].variation_id,
                            prices.qty,
                            prices.options[0].product_id
                        )
                    }
                    className="bg-yellow-200 text-yellow-900 px-4 py-2 text-white rounded mr-2 font-bold hover:bg-yellow-400"
                >
                    Volgende stap
                </button>
            </div>
        </div>
    );
};

export default Verspreiddatum;
